import type { MemoramaDeck } from '../engines/MemoramaEngine';

// Para agregar un deck nuevo: agrega otro objeto al array — el engine lo
// incluye en la rotación de "Jugar de nuevo". Mantén 6 pares por deck para que
// el grid de 4 columnas cierre parejo.
export const MEMORAMA_DECKS: MemoramaDeck[] = [
	{
		id: 'fiscal',
		title: 'Memorama fiscal',
		emoji: '🃏',
		pairs: [
			{ pairId: 'factura', emoji: '🧾', label: 'Factura' },
			{ pairId: 'saldo', emoji: '💸', label: 'Saldo a favor' },
			{ pairId: 'declaracion', emoji: '📊', label: 'Declaración' },
			{ pairId: 'efirma', emoji: '🔐', label: 'e.firma' },
			{ pairId: 'deduccion', emoji: '👓', label: 'Deducción' },
			{ pairId: 'cumplido', emoji: '✅', label: 'Al corriente' },
		],
	},
	{
		id: 'deducibles',
		title: 'Memorama de deducibles',
		emoji: '🩺',
		pairs: [
			{ pairId: 'consulta', emoji: '🩺', label: 'Consulta médica' },
			{ pairId: 'dentista', emoji: '🦷', label: 'Dentista' },
			{ pairId: 'colegiatura', emoji: '🎓', label: 'Colegiatura' },
			{ pairId: 'hipoteca', emoji: '🏠', label: 'Hipoteca' },
			{ pairId: 'lentes', emoji: '👓', label: 'Lentes' },
			{ pairId: 'retiro', emoji: '🪙', label: 'Ahorro retiro' },
		],
	},
	{
		id: 'tramites',
		title: 'Memorama de trámites',
		emoji: '🗂️',
		pairs: [
			{ pairId: 'rfc', emoji: '🪪', label: 'RFC' },
			{ pairId: 'contrasena', emoji: '🔑', label: 'Contraseña SAT' },
			{ pairId: 'efirma', emoji: '🔏', label: 'e.firma' },
			{ pairId: 'buzon', emoji: '📬', label: 'Buzón tributario' },
			{ pairId: 'cfdi', emoji: '🧾', label: 'CFDI' },
			{ pairId: 'constancia', emoji: '📄', label: 'Constancia' },
		],
	},
];
